import { Component, inject, output, signal } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { LandAdminCmd } from '@app/shared/classes/land';
import { BackendService } from '@app/shared/services/backend.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-stammdaten-land-new',
  templateUrl: './admin-stammdaten-land-new.component.html',
  imports: [
    MatTooltip,
    TranslatePipe,
    ReactiveFormsModule,
  ],
})
export class AdminStammdatenLandNewComponent {
  private readonly backendService = inject(BackendService);
  private readonly translateService = inject(TranslateService);
  private readonly formBuilder = inject(UntypedFormBuilder);

  readonly reloadEntries = output();

  protected readonly newLandForm = signal(this.generateForm());

  private generateForm(): UntypedFormGroup {
    return this.formBuilder.group({
      bezeichnungDe_new  : ['', Validators.required],
      bezeichnungFr_new  : ['', Validators.required],
      bezeichnungIt_new  : ['', Validators.required],
      sortierung_new     : ['', [Validators.pattern('^[0-9]*$'), Validators.required]],
      zulassungsLand_new : [''],
      importLand_new     : [''],
      nutztier_new       : [''],
      heimtier_new       : ['']
    });
  }

  protected submit() {
    const formValues = this.newLandForm().value;
    const land = new LandAdminCmd({
      bezeichnungDe   : formValues.bezeichnungDe_new,
      bezeichnungFr   : formValues.bezeichnungFr_new,
      bezeichnungIt   : formValues.bezeichnungIt_new,
      sortierung      : formValues.sortierung_new,
      zulassungsLand  : formValues.zulassungsLand_new,
      importLand      : formValues.importLand_new,
      nutztierErlaubt : formValues.nutztier_new,
      heimtierErlaubt : formValues.heimtier_new,
    });
    this.backendService.createLand(land)
      .subscribe({
        next: () => {
          this.reset();
          this.reloadEntries.emit();
        },
        error: error => {
          this.showAlert();
          console.error(error);
        }
      });
  }

  protected reset() {
    this.newLandForm.set(this.generateForm());
  }

  private showAlert() {
    Swal.fire({
      text              : this.translateService.instant('admin.land.save.error'),
      icon              : 'error',
      buttonsStyling    : true,
      confirmButtonText : this.translateService.instant('global.ok')
    });
  }
}
